import {
  HOME_FETCH_PROJECT_BEGIN,
  HOME_FETCH_PROJECT_SUCCESS,
  HOME_FETCH_PROJECT_FAILURE,
  HOME_FETCH_PROJECT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';
export function fetchProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_FETCH_PROJECT_BEGIN,
    });
    const { projectId } = args;
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}projects/${projectId}`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_FETCH_PROJECT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_FETCH_PROJECT_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>fetchProject', err);
        },
      );
    });

    return promise;
  };
}
export function dismissFetchProjectError() {
  return {
    type: HOME_FETCH_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_PROJECT_BEGIN:
      return {
        ...state,
        fetchProjectPending: true,
        fetchProjectError: null,
      };

    case HOME_FETCH_PROJECT_SUCCESS:
      return {
        ...state,
        fetchProjectPending: false,
        fetchProjectError: null,
        project: action.data,
      };

    case HOME_FETCH_PROJECT_FAILURE:
      return {
        ...state,
        fetchProjectPending: false,
        fetchProjectError: action.data.error,
      };

    case HOME_FETCH_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        fetchProjectError: null,
      };

    default:
      return state;
  }
}
